import { computed } from 'vue';
import { AppPermissions } from '@/shared/permissions';
import { useCoreStore } from '../../stores/core/store';

export default () => {
  const store = useCoreStore();

  const hasPermission = (permissionToCheck: string | undefined): boolean =>
    permissionToCheck ? store.hasPermission(permissionToCheck).value : true;


  return {
    hasPermission,
  };
};
